<template>
  <div class="row">
    <div class="col-12 col-lg-4">
      <div class="card card-body">
        <h1>{{ stats.users }}</h1>
        المستخدمين
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card card-body">
        <h1>{{ stats.devices }}</h1>
        الأجهرة
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      stats: {}
    }
  },
  created(){
    var g = this;
    $.post(api + '/admin/stats', {
        jwt: this.user.jwt
    }).then(function(r){
        g.loading = false
        if(r.status != 100){
            alert(r.response)
        }else{
            g.stats = r.response
        }
    }).fail(function(){
        g.loading = false
    })
  },
  methods: {
  }
}
</script>

<style>

</style>